export default "__VITE_ASSET__Dz9DMR2E__"